module.exports = __webpack_public_path__ + "img/fourday_ps_26.94209184.jpg";